export const Downloads = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Downloads</h1>
        </div>
    )
}